/* DYO theme — progressive enhancement only. Nothing here is required to shop. */
(function () {
  (function () {
    var nav = document.getElementById('header-nav');
    var backdrop = document.querySelector('[data-nav-backdrop]');
    var toggle = document.querySelector('[data-nav-toggle]');
    if (!nav || !backdrop || !toggle) return;

    function setOpen(open) {
      nav.setAttribute('data-open', open ? 'true' : 'false');
      backdrop.setAttribute('data-open', open ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    toggle.addEventListener('click', function () {
      setOpen(nav.getAttribute('data-open') !== 'true');
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-close]') || e.target === backdrop) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('data-open') === 'true') setOpen(false);
    });
  })();

  // Quantity steppers (cart + PDP)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    if (input.form && input.hasAttribute('data-autosubmit')) input.form.submit();
  });

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-gallery-thumb]');
    if (!th) return;
    var wrap = th.closest('[data-gallery]');
    var main = wrap && wrap.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = th.getAttribute('data-full');
    main.alt = th.getAttribute('data-alt') || '';
    wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (n) { n.setAttribute('aria-pressed', 'false'); });
    th.setAttribute('aria-pressed', 'true');
  });

  // Honeypot: a real visitor never sees or fills this field, so any value
  // in it means the submission is a bot — block it before it reaches Shopify.
  document.addEventListener('submit', function (e) {
    var honeypot = e.target.querySelector('[data-contact-honeypot]');
    if (honeypot && honeypot.value.trim() !== '') {
      e.preventDefault();
    }
  });

  // Prevent double-submitting forms with a submit button flagged data-contact-submit
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var btn = e.target.querySelector('[data-contact-submit]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Sending…';
  });
})();
